import { ServiceFetch } from '../service-fetch'

export default class ShortcutProductListModel extends ServiceFetch {
    getShortcutProductListBy = (data) => this.authFetch({
        url: 'shortcut-product-list/getShortcutProductListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}